module.exports = __webpack_public_path__ + "static/media/road_map.7434241e.png";